import { Link } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CloudDiagramsPreview from "../../../assets/clouddiagrams/dashboard-preview.jpg";
// import { FAQAccordion } from '../../../Components/FAQ/FAQAccordion';
import { useCustomerContext } from "../../../Context/CustomerContext";
import { useFullScreen } from "../../../utils/dialog";
import useSegmentTrackEvent from "../../../utils/useSegmentTrackEvent";
import AvailabilityChips from "./AvailabilityChips";
import IntroTour from "./IntroTour";
// const faqs = [
//   {
//     question: "What is Cloud Diagrams?",
//     answer:
//       "DoiT Cloud Diagrams is a powerful and versatile tool that generates diagrams of your AWS cloud infrastructure. When connecting your AWS accounts, Cloud Diagrams creates one diagram for every AWS account, allowing you to visualize and analyze your resources and understand the relationships between them.",
//   },
//   {
//     question: "How regularly will the diagrams be refreshed?",
//     answer:
//       "Cloud Diagrams automatically updates every 4 hours. You can also manually refresh the data at any time by selecting Refresh.",
//   },
//   {
//     question: "What permissions are required to start using Cloud Diagrams?",
//     answer: (
//       <Typography variant="body2">
//         Cloud Diagrams utilizes AWS-managed SecurityAudit policy and a few extra permissions in order to read
//         infrastructure metadata. Please, check <a href="https://help.doit.com/docs/governance/cloud-diagrams">here</a>{" "}
//         for more details.
//       </Typography>
//     ),
//   },
//   {
//     question: "Which cloud service providers are currently supported in Cloud Diagrams?",
//     answer:
//       "Cloud Diagrams currently supports architecture visualizations for AWS. Google Cloud Platform and Microsoft Azure coming soon.",
//   },
//   {
//     question: "What level of details can I view in a Cloud Diagram?",
//     answer:
//       "Cloud Diagrams provides an architecture level visualization at a service/resource level, network level view as well as detailed resource property data.",
//   },
//   {
//     question: "What insights can I expect to gain?",
//     answer:
//       "Cloud Diagrams maintains an up to date visualization of your entire infrastructure without the need to switch between regions and services in AWS console. When troubleshooting or assessing a service architecture, it saves a lot of time and avoids costly mistakes by learning of dependencies and connections to other services and accounts.",
//   },
// ];

const DefaultPage = () => {
  const { customer } = useCustomerContext();
  const { isMobile } = useFullScreen();
  const { trackEvent } = useSegmentTrackEvent({ allowNullUser: false });

  const handleCreateDiagramClick = () => {
    trackEvent("Clouddiagrams Create Diagram Clicked", {
      pageType: "Governance",
      pageSubType: "CloudDiagrams",
      feature: "CloudDiagrams",
      isPageOpenEvent: false,
    });
  };

  return (
    <Box>
      <Container maxWidth="lg" sx={{ pb: 8, mt: 4 }}>
        <Grid
          container
          spacing={12}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid size={{ sm: 12, md: 6 }}>
            <Box>
              <Typography
                variant="h1"
                sx={{ fontSize: "36px", lineHeight: "44px", mb: "6px" }}
                data-cy="clouddiagrams-title"
              >
                Visualize your cloud infrastructure in real-time
              </Typography>
              <Stack direction="row" spacing={1}>
                <AvailabilityChips />
              </Stack>
              <Typography variant="body1" sx={{ m: "26px 0" }}>
                Cloud Diagrams creates an always up-to-date visual map of your cloud infrastructure, enabling faster
                incident resolution, better change management, and enhanced cross-team collaboration
              </Typography>
              <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                {!isMobile && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to={`/customers/${customer.id}/analyze/cloud-diagrams/onboarding`}
                    data-cy="clouddiagrams-create-first-diagram"
                    onClick={handleCreateDiagramClick}
                  >
                    Create your first diagram
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<OpenInNewIcon />}
                  component={"a"}
                  href="https://help.doit.com/docs/governance/cloud-diagrams/create"
                  data-cy="clouddiagrams-learn-more"
                >
                  Learn more
                </Button>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ sm: 12, md: 6 }}>
            <Card sx={{ width: "100%", height: "auto" }}>
              <CardMedia
                component="img"
                image={CloudDiagramsPreview}
                alt="Cloud Diagrams Preview"
                sx={{
                  width: "100%",
                  height: "auto",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
                }}
                data-cy="clouddiagrams-preview-image"
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <IntroTour />
      {/* <Stack>
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Stack spacing={2}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "500",
              }}
              data-cy="clouddiagrams-faq-title"
            >
              Frequently asked questions
            </Typography>
            <FAQAccordion faqs={faqs} data-cy="clouddiagrams-faq-accordion" />
          </Stack>
        </Container>
      </Stack> */}
    </Box>
  );
};

export default DefaultPage;
